module.exports = __webpack_public_path__ + "img/neck_width.779371c7.png";